import type { RouteObject } from 'react-router-dom';

import { AppShellProviders } from '@/components/common/AppShellProviders';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';

import { NumbersPage } from './pages/NumbersPage';

/**
 * Numbers feature routes (P4-T6, design §5) — flat glob registry
 * (`src/features/registry.ts`), own `ProtectedRoute → AppShellProviders →
 * AppLayout` tree re-declaring the `/organizations/:orgId` prefix exactly
 * like the projects/agents trees (branches never collide).
 *
 *   /organizations/:orgId/numbers   NumbersPage
 *
 * No `nav.ts` (deviation from design §5, forced by the landed registry):
 * `components/layout/nav.ts` items carry a literal `to` with no `:orgId`
 * interpolation, so org-scoped features are reached through their organization
 * (same stance as projects/agents, which ship no nav either). The sidebar/nav
 * entry is an orgs-feature (P1-owned) surface decision — reported to the
 * orchestrator rather than patched across owners.
 */
export const routes: RouteObject[] = [
  {
    path: '/organizations/:orgId/numbers',
    element: (
      <ProtectedRoute>
        <AppShellProviders>
          <AppLayout />
        </AppShellProviders>
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <NumbersPage /> }],
  },
];
